module.exports = __webpack_public_path__ + "img/calhoun-logo.5ab29a41.jpg";